import { createFileRoute } from '@tanstack/react-router';
import { NewCampaignPage } from '@/features/marketing';

/**
 * New campaign › Just a flyer page: the classic flyer + caption screen, kept for people used to it. It makes a campaign
 * with no shape.
 *
 * To retire it, delete this route and `classic-flyer-page-row.tsx`, the row's import and JSX line in
 * `campaign-shape-picker-page.tsx`, the row's test in `campaign-shape-picker-page.test.tsx`, and this route's entry in
 * `marketing-nav-items.test.ts`. A web build then drops it from the tracked `routeTree.gen.ts`. Leave the API alone: old
 * campaigns keep their null shape.
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/new_/flyer-page')({
  component: NewClassicFlyerPageRoute,
});

function NewClassicFlyerPageRoute() {
  const { orgId } = Route.useParams();
  return <NewCampaignPage orgId={orgId} />;
}
